/* Feel Espresso: animations + AJAX mini cart. No dependencies. */
(function () {
  'use strict';
  var d = document;
  var root = d.documentElement;
  var $ = function (s, c) { return (c || d).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || d).querySelectorAll(s)); };
  var mm = function (q) { return !!(window.matchMedia && window.matchMedia(q).matches); };
  var reduce = mm('(prefers-reduced-motion: reduce)');
  var fine = mm('(pointer: fine)');
  var hasView = !!(window.CSS && CSS.supports && CSS.supports('animation-timeline: view()'));

  /* ---------- reveal fallback (Safari, Firefox: no scroll-driven animations) ---------- */
  var io = null;
  function initReveal() {
    if (hasView || reduce || !('IntersectionObserver' in window)) return;
    root.classList.add('fe-fb');
    if (!io) {
      io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            e.target.classList.add('fe-on');
            io.unobserve(e.target);
          }
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });
    }
    $$('.fe-rv:not(.fe-on), .fe-t:not(.fe-on)').forEach(function (el) {
      var p = el.parentElement;
      el.style.setProperty('--d', Math.min(p ? Array.prototype.indexOf.call(p.children, el) % 4 : 0, 5));
      io.observe(el);
    });
  }

  /* ---------- scroll: progress bar fallback + back to top ---------- */
  var ticking = false;
  function onScroll() {
    ticking = false;
    var pg = $('.fe-pg');
    var topBtn = $('.fe-top');
    var y = window.pageYOffset || root.scrollTop || 0;
    if (!hasView && !reduce && pg) {
      var h = root.scrollHeight - window.innerHeight;
      pg.style.transform = 'scaleX(' + (h > 0 ? Math.min(y / h, 1) : 0) + ')';
    }
    if (topBtn) topBtn.classList.toggle('is-on', y > 500);
  }
  window.addEventListener('scroll', function () {
    if (!ticking) {
      ticking = true;
      window.requestAnimationFrame(onScroll);
    }
  }, { passive: true });

  /* ---------- tilt cards + magnetic hero buttons (mouse only) ---------- */
  if (fine && !reduce) {
    d.addEventListener('pointermove', function (e) {
      var t = e.target && e.target.closest ? e.target : null;
      if (!t) return;
      var c = t.closest('[data-tilt]');
      if (c) {
        var r = c.getBoundingClientRect();
        c.style.setProperty('--ry', (((e.clientX - r.left) / r.width - 0.5) * 10).toFixed(2) + 'deg');
        c.style.setProperty('--rx', (-((e.clientY - r.top) / r.height - 0.5) * 10).toFixed(2) + 'deg');
      }
      var b = t.closest('.fe-hl .fe-btn');
      if (b) {
        var q = b.getBoundingClientRect();
        b.style.translate = ((e.clientX - q.left - q.width / 2) * 0.18).toFixed(1) + 'px ' + ((e.clientY - q.top - q.height / 2) * 0.28).toFixed(1) + 'px';
      }
    }, { passive: true });
    d.addEventListener('pointerout', function (e) {
      var t = e.target && e.target.closest ? e.target : null;
      if (!t) return;
      var c = t.closest('[data-tilt]');
      if (c && !c.contains(e.relatedTarget)) {
        c.style.removeProperty('--rx');
        c.style.removeProperty('--ry');
      }
      var b = t.closest('.fe-hl .fe-btn');
      if (b && !b.contains(e.relatedTarget)) b.style.translate = '';
    });
  }

  /* ---------- variant picker on cards: show the selected variant's price ---------- */
  d.addEventListener('change', function (e) {
    var s = e.target;
    if (!s || !s.matches || !s.matches('select[data-fe-variant]')) return;
    var o = s.options[s.selectedIndex];
    var card = s.closest('.fe-cd');
    var price = card && $('[data-fe-price]', card);
    if (o && price && o.getAttribute('data-price')) price.textContent = o.getAttribute('data-price');
  });

  /* ---------- mini cart ---------- */
  var drawer = $('#fe-drawer');
  var pageMode = !drawer || drawer.getAttribute('data-mode') === 'page';
  var cartPage = (drawer && drawer.getAttribute('data-cart-page')) || '/cart';
  var cartUrl = cartPage + '.js';
  var changeUrl = (drawer && drawer.getAttribute('data-change')) || '/cart/change.js';
  var lastFocus = null;
  var bridgeFocus = null;

  function money(cents, cur) {
    try {
      return new Intl.NumberFormat(root.lang || undefined, { style: 'currency', currency: cur }).format(cents / 100);
    } catch (e) {
      return (cents / 100).toFixed(2) + ' ' + cur;
    }
  }
  function getJSON(u) {
    return fetch(u, { headers: { Accept: 'application/json' }, credentials: 'same-origin' }).then(function (r) { return r.json(); });
  }
  function postJSON(u, body) {
    return fetch(u, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json(); });
  }
  function isError(res) { return !!(res && res.status && (res.message || res.description)); }
  function msg(t) {
    var m = drawer && $('[data-fe-msg]', drawer);
    if (m) m.textContent = t || '';
  }
  function mkBtn(txt, act, label) {
    var b = d.createElement('button');
    b.type = 'button';
    b.setAttribute('data-act', act);
    b.setAttribute('aria-label', label);
    b.textContent = txt;
    return b;
  }

  function render(cart) {
    $$('[data-fe-count]').forEach(function (n) { n.textContent = cart.item_count; });
    if (!drawer) return cart;
    var list = $('[data-fe-list]', drawer);
    var empty = $('[data-fe-empty]', drawer);
    var foot = $('.fe-dr-f', drawer);
    list.textContent = '';
    cart.items.forEach(function (it, i) {
      var li = d.createElement('li');
      li.className = 'fe-dr-i';
      li.style.animationDelay = (i * 60) + 'ms';
      var img = d.createElement('img');
      img.alt = '';
      img.width = 72;
      img.height = 72;
      var src = (it.featured_image && it.featured_image.url) || it.image;
      if (src) img.src = src;
      li.appendChild(img);
      var mid = d.createElement('div');
      var a = d.createElement('a');
      a.href = it.url;
      a.textContent = it.product_title;
      a.style.fontWeight = '600';
      mid.appendChild(a);
      if (it.variant_title) {
        var s = d.createElement('small');
        s.textContent = it.variant_title;
        mid.appendChild(s);
      }
      var q = d.createElement('div');
      q.className = 'fe-q';
      var dec = mkBtn('−', 'dec', 'Decrease quantity of ' + it.product_title);
      var inc = mkBtn('+', 'inc', 'Increase quantity of ' + it.product_title);
      var n = d.createElement('span');
      n.textContent = it.quantity;
      q.appendChild(dec);
      q.appendChild(n);
      q.appendChild(inc);
      mid.appendChild(q);
      li.appendChild(mid);
      var pr = d.createElement('div');
      pr.className = 'fe-dr-pr';
      var b = d.createElement('b');
      b.textContent = money(it.final_line_price, cart.currency);
      pr.appendChild(b);
      var rm = d.createElement('button');
      rm.type = 'button';
      rm.className = 'fe-rm';
      rm.setAttribute('data-act', 'rm');
      rm.textContent = 'Remove';
      pr.appendChild(rm);
      li.appendChild(pr);
      [dec, inc, rm].forEach(function (x) {
        x.setAttribute('data-line', i + 1);
        x.setAttribute('data-qty', it.quantity);
      });
      list.appendChild(li);
    });
    empty.hidden = cart.item_count > 0;
    foot.hidden = cart.item_count === 0;
    $('[data-fe-sub]', drawer).textContent = money(cart.items_subtotal_price, cart.currency);
    return cart;
  }

  function open(from) {
    if (!drawer) return;
    lastFocus = from || d.activeElement;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    root.style.overflow = 'hidden';
    setTimeout(function () {
      var p = $('.fe-dr-p', drawer);
      if (p) p.focus();
    }, 50);
  }
  function close() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    root.style.overflow = '';
    msg('');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  function bump() {
    $$('[data-fe-cart]').forEach(function (c) {
      c.classList.remove('fe-bump');
      void c.offsetWidth;
      c.classList.add('fe-bump');
    });
  }
  function refreshAndOpen(from) {
    return getJSON(cartUrl).then(render).then(function () {
      bump();
      open(from);
    });
  }
  function fly(form) {
    if (reduce || !form.closest) return;
    var card = form.closest('.fe-cd');
    var src = card && ($('.fe-pic img', card) || $('.fe-bag', card));
    var target = $('[data-fe-cart]');
    if (!src || !target || !src.animate) return;
    var a = src.getBoundingClientRect();
    var b = target.getBoundingClientRect();
    var clone = src.cloneNode(true);
    clone.removeAttribute('id');
    clone.className = (clone.className ? clone.className + ' ' : '') + 'fe-fly';
    clone.style.left = a.left + 'px';
    clone.style.top = a.top + 'px';
    clone.style.width = a.width + 'px';
    clone.style.height = a.height + 'px';
    d.body.appendChild(clone);
    var dx = b.left + b.width / 2 - (a.left + a.width / 2);
    var dy = b.top + b.height / 2 - (a.top + a.height / 2);
    var anim = clone.animate([
      { transform: 'translate(0,0) scale(1)', opacity: 1 },
      { transform: 'translate(' + dx + 'px,' + dy + 'px) scale(.12)', opacity: 0.3 }
    ], { duration: 750, easing: 'cubic-bezier(.55,-.15,.35,1)' });
    anim.onfinish = function () { clone.remove(); };
  }

  /* Bridge for Dawn's own add-to-cart (product pages, quick add):
     Dawn's product form looks for a <cart-notification> element and calls these three methods. */
  if (drawer && !pageMode && window.customElements && !window.customElements.get('cart-notification')) {
    window.customElements.define('cart-notification', class extends HTMLElement {
      getSectionsToRender() { return [{ id: 'cart-icon-bubble' }]; }
      setActiveElement(el) { bridgeFocus = el; }
      renderContents() {
        refreshAndOpen(bridgeFocus).catch(function () { window.location.href = cartPage; });
      }
    });
  }

  function onCartPage() {
    return /^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?cart\/?$/i.test(window.location.pathname);
  }

  d.addEventListener('click', function (e) {
    var t = e.target && e.target.closest ? e.target : null;
    if (!t || !drawer || pageMode) return;
    var link = t.closest('[data-fe-cart]');
    if (link) {
      if (onCartPage() || e.metaKey || e.ctrlKey || e.shiftKey) return;
      e.preventDefault();
      getJSON(cartUrl).then(render).then(function () { open(link); }).catch(function () { window.location.href = link.href; });
      return;
    }
    if (t.closest('[data-fe-close]')) {
      close();
      return;
    }
    var act = t.closest('[data-act]');
    if (act && drawer.contains(act)) {
      var line = +act.getAttribute('data-line');
      var qty = +act.getAttribute('data-qty');
      var a = act.getAttribute('data-act');
      var nq = a === 'inc' ? qty + 1 : a === 'dec' ? qty - 1 : 0;
      act.disabled = true;
      postJSON(changeUrl, { line: line, quantity: nq })
        .then(function (cart) {
          if (isError(cart)) {
            msg(cart.description || cart.message);
            return getJSON(cartUrl).then(render);
          }
          msg('');
          return render(cart);
        })
        .catch(function () { msg('Something went wrong. Please try again.'); });
    }
  });

  d.addEventListener('submit', function (e) {
    var f = e.target;
    if (!drawer || pageMode || !f || !f.matches || !f.matches('form[data-fe-add]')) return;
    e.preventDefault();
    var b = $('button[type="submit"]', f);
    var label = b ? b.textContent : '';
    if (b) {
      b.disabled = true;
      b.textContent = 'Adding…';
    }
    fetch(f.getAttribute('data-fe-add'), { method: 'POST', body: new FormData(f), headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (isError(res)) throw new Error(res.description || res.message);
        fly(f);
        return getJSON(cartUrl);
      })
      .then(function (cart) {
        render(cart);
        bump();
        msg('');
        if (b) {
          b.textContent = 'Added';
          b.classList.add('is-added');
        }
        setTimeout(function () { open(b); }, reduce ? 0 : 450);
      })
      .catch(function (err) {
        msg(err && err.message ? err.message : 'Could not add this item.');
        open(b);
      })
      .then(function () {
        if (b) {
          setTimeout(function () {
            b.disabled = false;
            b.textContent = label;
            b.classList.remove('is-added');
          }, 1600);
        }
      });
  });

  d.addEventListener('keydown', function (e) {
    if (!drawer || !drawer.classList.contains('is-open')) return;
    if (e.key === 'Escape') {
      close();
      return;
    }
    if (e.key === 'Tab') {
      var f = $$('a[href],button:not([disabled])', drawer).filter(function (x) { return !x.closest('[hidden]'); });
      if (!f.length) return;
      var first = f[0];
      var last = f[f.length - 1];
      if (e.shiftKey && (d.activeElement === first || d.activeElement === $('.fe-dr-p', drawer))) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && d.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }
  });

  window.addEventListener('pageshow', function (e) {
    if (e.persisted) getJSON(cartUrl).then(render).catch(function () {});
  });
  d.addEventListener('shopify:section:load', function () {
    initReveal();
    onScroll();
  });

  initReveal();
  onScroll();
})();